import React, { FC, useEffect } from 'react';
import { PersonalDetails } from './style';
import FormInputField from 'components/FormInputField';
import { colors } from 'constants/colors';
import StyledButton from 'components/Button';
import Hint from 'components/Hint';
import { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { userInfoState } from 'states/CheckOutStates/atoms'
import CountryProvinceFields from 'components/CountryProvinceFields';

import { useUpdatePersonalDetails } from 'customHooks/useUpdatePersonalDetails';


// task RHCFW-226
// For updating user details in the first form use updateUser mutation.
// for changing email use sendEmailVerification and then  changeEmail mutation.
// for phoneNumber, use sendPhoneNumberVerification and then changePhoneNumber


const debug = false;


const PersonalDetailsContent: FC = () => {

  // const formatDateToDDMMYYYY = (date: string): string => {
  //   if (date) {
  //     const parsedDate = new Date(date); 
  //     const day = String(parsedDate.getDate()).padStart(2, '0'); 
  //     const month = String(parsedDate.getMonth() + 1).padStart(2, '0'); 
  //     const year = parsedDate.getFullYear(); 
  //     return `${day}/${month}/${year}`; 
  //   }
  //   else {
  //     return ('');
  //   }
  // };


  // const formatDateToYYYYMMDD = (date: string): string => {
  //   const [day, month, year] = date.split('/'); 
  //   return `${year}-${month}-${day}`; 
  // };

  const formatDateToDDMMYYYY = (date: string): string => {
    if (!date) return '';

    const parsedDate = new Date(date); // Date in UTC
    const day = String(parsedDate.getUTCDate()).padStart(2, '0');
    const month = String(parsedDate.getUTCMonth() + 1).padStart(2, '0');
    const year = parsedDate.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatDateToISO = (date: string): string => {
    const [day, month, year] = date.split('/').map(Number);
    const utcDate = new Date(Date.UTC(year, month - 1, day)); // Set date to UTC
    return utcDate.toISOString(); // Converting date to ISO 8601
  };

  const { savePersonalDetails } = useUpdatePersonalDetails();
  const userInfo = useRecoilValue(userInfoState);

  useEffect(() => {
    setFullNameValue(userInfo.fullNameInput || '');

    setAddressValue(userInfo.mailAddressInput || '');
    setStreetAddressLine2Value(userInfo.addressLine2Input || '');
    setCityValue(userInfo.cityInput || '');
    setProvinceValue(userInfo.provinceInput || '');
    setPostalCodeValue(userInfo.postalCodeInput || '');
    setCountryValue(userInfo.countryInput || '');

    setPhoneValue(userInfo.phoneNumberInput || '');
    setDateOfBirth(
      formatDateToDDMMYYYY(userInfo.dateOfBirth) || ''
    );
  }, [userInfo]);

  if (debug) {
    console.log("userInfo:", userInfo);
  }

  const isValidDate = (date: string): boolean => {
    const [day, month, year] = date.split('/').map(Number);

    if (!day || !month || !year) return false;

    const parsedDate = new Date(Date.UTC(year, month - 1, day));

    return (
      parsedDate.getUTCFullYear() === year &&
      parsedDate.getUTCMonth() === month - 1 &&
      parsedDate.getUTCDate() === day
    );
  };

  const isAtLeast19YearsOld = (date: string): boolean => {
    const [day, month, year] = date.split('/').map(Number);
    const birthDate = new Date(Date.UTC(year, month - 1, day));
    const today = new Date();

    const minimumBirthDate = new Date(
      Date.UTC(
        today.getUTCFullYear() - 19,
        today.getUTCMonth(),
        today.getUTCDate()
      )
    );

    return birthDate <= minimumBirthDate;
  };

  //const [isLoading, setIsLoading] = useState(true); // loading indicator
  const [fullNameValue, setFullNameValue] = useState(userInfo.fullNameInput);

  const [addressValue, setAddressValue] = useState(
    userInfo.mailAddressInput || ''
  );

  const [streetAddressLine2Value, setStreetAddressLine2Value] = useState(
    userInfo.addressLine2Input || ''
  );

  const [cityValue, setCityValue] = useState(
    userInfo.cityInput || ''
  );

  const [provinceValue, setProvinceValue] = useState(
    userInfo.provinceInput || ''
  );

  const [postalCodeValue, setPostalCodeValue] = useState(
    userInfo.postalCodeInput || ''
  );

  const [countryValue, setCountryValue] = useState(
    userInfo.countryInput || ''
  );

  const [, setPhoneValue] = useState(userInfo.phoneNumberInput);



  const [dateOfBirth, setDateOfBirth] = useState(formatDateToDDMMYYYY(userInfo.dateOfBirth));
  const [isCleared, setIsCleared] = useState(false); // Indicator to track if the field has been cleared

  const [showHint, setShowHint] = useState<boolean>(false);


  useState(false);


  const [errorMessageFullName, setErrorMessageFullName] = useState(false);
  const [errorMessageFullNameText, setErrorMessageFullNameText] = useState('');

  const [errorMessageAddress, setErrorMessageAddress] = useState(false);
  const [errorMessageAddressText, setErrorMessageAddressText] = useState('');

  const [
    errorMessageStreetAddressLine2,
    setErrorMessageStreetAddressLine2
  ] = useState(false);

  const [
    errorMessageStreetAddressLine2Text,
    setErrorMessageStreetAddressLine2Text
  ] = useState('');

  const [errorMessageCity, setErrorMessageCity] = useState(false);
  const [errorMessageCityText, setErrorMessageCityText] = useState('');

  const [errorMessageProvince, setErrorMessageProvince] = useState(false);
  const [errorMessageProvinceText, setErrorMessageProvinceText] = useState('');

  const [errorMessagePostalCode, setErrorMessagePostalCode] = useState(false);
  const [errorMessagePostalCodeText, setErrorMessagePostalCodeText] = useState('');

  const [errorMessageCountry, setErrorMessageCountry] = useState(false);
  const [errorMessageCountryText, setErrorMessageCountryText] = useState('');

  const [errorMessageDateOfBirth, setErrorMessageDateOfBirth] = useState(false);
  const [errorMessageDateOfBirthText, setErrorMessageDateOfBirthText] = useState('');


  useEffect(() => {
    if (debug) {
      console.log("dateOfBirth:", dateOfBirth);
    }

  }, [dateOfBirth]);


  const handleSavePersonalDetails = () => {
    let noErrors = true;

    //    setSaveSucsessMessage(true);


    if (fullNameValue.length < 2) {
      setErrorMessageFullNameText("Please, enter correct Full name.");
      setErrorMessageFullName(true);
      noErrors = false;
    }
    if (addressValue.trim().length < 2) {
      setErrorMessageAddressText('Please, enter correct street address.');
      setErrorMessageAddress(true);
      noErrors = false;
    }
    if (!isValidDate(dateOfBirth)) {
      setErrorMessageDateOfBirthText('Please, enter a valid date.');
      setErrorMessageDateOfBirth(true);
      noErrors = false;
    } else if (!isAtLeast19YearsOld(dateOfBirth)) {
      setErrorMessageDateOfBirthText(
        'The primary guest must be at least 19 years old.'
      );
      setErrorMessageDateOfBirth(true);
      noErrors = false;
    } else {
      setErrorMessageDateOfBirth(false);
    }
    const trimmedAddressLine2 = streetAddressLine2Value.trim();

    if (trimmedAddressLine2.length > 0 && trimmedAddressLine2.length < 2) {
      setErrorMessageStreetAddressLine2Text(
        'Please, enter correct street address line 2.'
      );
      setErrorMessageStreetAddressLine2(true);
      noErrors = false;
    } else {
      setErrorMessageStreetAddressLine2(false);
    }

    if (cityValue.trim().length < 2) {
      setErrorMessageCityText('Please, enter correct city.');
      setErrorMessageCity(true);
      noErrors = false;
    }

    if (provinceValue.trim().length < 2) {
      setErrorMessageProvinceText('Please, enter correct province or state.');
      setErrorMessageProvince(true);
      noErrors = false;
    }

    if (postalCodeValue.trim().length < 2) {
      setErrorMessagePostalCodeText('Please, enter correct postal or ZIP code.');
      setErrorMessagePostalCode(true);
      noErrors = false;
    }

    if (countryValue.trim().length < 2) {
      setErrorMessageCountryText('Please, enter correct country.');
      setErrorMessageCountry(true);
      noErrors = false;
    }

    if (noErrors) {
      setErrorMessageFullName(false);
      setErrorMessageAddress(false);
      setErrorMessageDateOfBirth(false);
      setErrorMessageStreetAddressLine2(false);
      setErrorMessageCity(false);
      setErrorMessageProvince(false);
      setErrorMessagePostalCode(false);
      setErrorMessageCountry(false);
      savePersonalDetails({
        fullName: fullNameValue.trim(),
        address: addressValue.trim(),
        addressLine2: streetAddressLine2Value.trim(),
        city: cityValue.trim(),
        province: provinceValue.trim(),
        postalCode: postalCodeValue.trim(),
        country: countryValue.trim(),
        dateOfBirth: formatDateToISO(dateOfBirth)
      });
    }
  };


  const handleMouseOver = () => {
    setShowHint(true);
  };

  const handleMouseOut = () => {
    setShowHint(false); // Hide hint
  };



  const formatDate = (value: string) => {
    // Remove all non-digit characters
    value = value.replace(/[^\d]/g, '');

    // Add slashes after the 2nd and 5th characters
    if (value.length >= 2) value = value.slice(0, 2) + '/' + value.slice(2);
    if (value.length >= 5) value = value.slice(0, 5) + '/' + value.slice(5);

    // Limit the length to 10 characters (dd/mm/yyyy)
    return value.slice(0, 10);
  };

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    setDateOfBirth(formatDate(value));
    setErrorMessageDateOfBirth(false);
    setErrorMessageDateOfBirthText('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (!isCleared) {
      // If the field has not been cleared, clear it and set the first entered character
      setIsCleared(true); // Mark that the field has been cleared
      setDateOfBirth(formatDate(e.key)); // Set the first entered character with slashes added
      e.preventDefault(); // Prevent default input to avoid adding the character twice
      setErrorMessageDateOfBirth(false);
      setErrorMessageDateOfBirthText('');
    }
  };


  const handleFullNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFullNameValue(e.target.value);
    setErrorMessageFullName(false);
    setErrorMessageFullNameText('');
  };
  
  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAddressValue(e.target.value);
    setErrorMessageAddress(false);
    setErrorMessageAddressText('');
  };
  
  const handleStreetAddressLine2Change = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setStreetAddressLine2Value(e.target.value);
    setErrorMessageStreetAddressLine2(false);
    setErrorMessageStreetAddressLine2Text('');
  };
  
  const handleCityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCityValue(e.target.value);
    setErrorMessageCity(false);
    setErrorMessageCityText('');
  };
  
  const handleProvinceChange = (value: string) => {
    setProvinceValue(value);
    setErrorMessageProvince(false);
    setErrorMessageProvinceText('');
  };
  
  const handlePostalCodeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setPostalCodeValue(e.target.value);
    setErrorMessagePostalCode(false);
    setErrorMessagePostalCodeText('');
  };
  
  const handleCountryChange = (value: string) => {
    setCountryValue(value);
    setErrorMessageCountry(false);
    setErrorMessageCountryText('');
  };

  const handleFocus = () => {
    setIsCleared(false); // Reset the clearing state when focused
  };

  return (
    <PersonalDetails>


      <div className="accountBody">
        <div className="cardContent">
          <div className="topText">
            To make changes to your account please edit the information below. We ask for your date of birth to verify your age; <br />
            all primary guests at our hotel must be 19+ years old. We do not share or sell this information to any third parties.
          </div>
          <div className="addressFields">
            <div className="inpuntCont">
              <FormInputField
                className="secInput"
                // highLightLabel='CURRENT '
                label="FULL NAME"
                isRequired
                type="text"
                borderColor={colors.signInBorderColor}
                error={errorMessageFullName}
                errorMessage={errorMessageFullNameText}
                // value={oldPassword}
                inputHeight="48px"
                marginBottom="1px"
                value={fullNameValue}
                maxLength={300}
                onChange={handleFullNameChange}
              />
            </div>

            <div className="inpuntCont streetAddress">
              <FormInputField
                className="secInput"
                label="STREET ADDRESS"
                isRequired
                type="text"
                borderColor={colors.signInBorderColor}
                error={errorMessageAddress}
                errorMessage={errorMessageAddressText}
                value={addressValue}
                inputHeight="48px"
                marginBottom="1px"
                onChange={handleAddressChange}
              />
            </div>

            <div className="inpuntCont streetAddressLine2">
              <FormInputField
                className="secInput"
                label="STREET ADDRESS LINE 2"
                type="text"
                borderColor={colors.signInBorderColor}
                value={streetAddressLine2Value}
                inputHeight="48px"
                marginBottom="1px"
                error={errorMessageStreetAddressLine2}
                errorMessage={errorMessageStreetAddressLine2Text}
                onChange={handleStreetAddressLine2Change}
              />
            </div>

            <div className="addressRow">
              <div className="inpuntCont">
                <FormInputField
                  className="secInput"
                  label="CITY"
                  isRequired
                  type="text"
                  borderColor={colors.signInBorderColor}
                  error={errorMessageCity}
                  errorMessage={errorMessageCityText}
                  value={cityValue}
                  inputHeight="48px"
                  marginBottom="0px"
                  onChange={handleCityChange}
                />
              </div>

              <div className="inpuntCont">
                <CountryProvinceFields
                  idPrefix="personal-details-province"
                  countryValue={countryValue}
                  provinceValue={provinceValue}
                  onCountryChange={handleCountryChange}
                  onProvinceChange={handleProvinceChange}
                  provinceError={errorMessageProvince}
                  provinceErrorMessage={errorMessageProvinceText}
                  showCountryField={false}
                  marginBottom="0px"
                />
              </div>
            </div>

            <div className="addressRow">
              <div className="inpuntCont">
                <FormInputField
                  className="secInput"
                  label="POSTAL / ZIP CODE"
                  isRequired
                  type="text"
                  borderColor={colors.signInBorderColor}
                  value={postalCodeValue}
                  error={errorMessagePostalCode}
                  errorMessage={errorMessagePostalCodeText}
                  inputHeight="48px"
                  marginBottom="0px"
                  onChange={handlePostalCodeChange}
                />
              </div>

              <div className="inpuntCont">
                <CountryProvinceFields
                  idPrefix="personal-details-country"
                  countryValue={countryValue}
                  provinceValue={provinceValue}
                  onCountryChange={handleCountryChange}
                  onProvinceChange={handleProvinceChange}
                  countryError={errorMessageCountry}
                  countryErrorMessage={errorMessageCountryText}
                  showProvinceField={false}
                  marginBottom="0px"

                />
              </div>
            </div>
          </div>
          <div className="inpuntCont dateOfBirth">
            <FormInputField
              className="secInput"
              // highLightLabel='CURRENT '
              label="DATE OF BIRTH (DD/MM/YYYY)"
              isRequired
              type="text"
              borderColor={colors.signInBorderColor}
              error={errorMessageDateOfBirth}
              errorMessage={errorMessageDateOfBirthText}
              value={dateOfBirth}
              onChange={handleDateChange}
              onClick={handleFocus}
              onFocus={handleFocus}
              onKeyDown={handleKeyDown} // Clear the field on the first input
              onMouseOver={handleMouseOver}
              onMouseOut={handleMouseOut}
              // maxLength={11}

              inputHeight="48px"
              marginBottom="16px"
              infoIcon
            />
            {/* <InfoCircle className="infoIcon"></InfoCircle> */}
            {showHint ? (
              <Hint
                title="Why do you need this?"
                message="To stay at our hotel, the primary guest must be 19+ years old."

                width="446"
                arrowPosition="22"
                positionBottom="88"
                positionLeft="200"

                widthTablet="446"
                arrowPositionTablet="223"
                positionBottomTablet="88"
                positionLeftTablet="0"

                widthMini="446"
                arrowPositionMini="223"
                positionBottomMini="88"
                positionLeftMini="-10"

                widthMobile="325"
                arrowPositionMobile="223"
                positionBottomMobile="88"
                positionLeftMobile="0"

              />
            ) : null}
          </div>
          <div className="saveButton">
            <StyledButton
              width="81px"
              height="48px"
              //backgroundColor = {colors.signInBorderColor}
              //fontColor = {colors.white}
              disabledBackgroundColor={colors.signInBorderColor}
              disabledColor={colors.white}
              // disabled={oldPassword.length < 8 || newPassword.length < 8}
              onClick={handleSavePersonalDetails}
            >
              Save
            </StyledButton>
          </div>
        </div>
      </div>
    </PersonalDetails>
  );
};

export default PersonalDetailsContent;
